document.addEventListener("pointerdown", (event) => {
  document.querySelectorAll(".header details.menu[open]").forEach((menu) => {
    if (!event.composedPath().includes(menu)) menu.open = false;
  });
});

document.addEventListener("click", (event) => {
  const link = event.target.closest(".header details.menu nav a");
  if (link) link.closest("details.menu").open = false;
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;
  document.querySelectorAll(".header details.menu[open]").forEach((menu) => {
    menu.open = false;
    menu.querySelector("summary")?.focus();
  });
});

document.addEventListener("DOMContentLoaded",()=>{const selector=document.querySelector("[data-product-variants]");const image=document.getElementById("BambasticMainProductImage");const price=document.querySelector("[data-product-price]");const button=document.querySelector("[data-product-add]");if(!selector)return;const defaultImage=image?.getAttribute("src");const defaultAlt=image?.getAttribute("alt");const update=()=>{const option=selector.options[selector.selectedIndex];if(!option)return;if(button){button.disabled=option.disabled;button.textContent=option.disabled?"Sold out":"Add to bag";}if(image){image.src=option.dataset.image||defaultImage||image.src;image.alt=option.dataset.image?(option.dataset.alt||defaultAlt||"Selected product option"):(defaultAlt||"Product photo");}if(price&&option.dataset.price)price.textContent=option.dataset.price;const url=new URL(window.location.href);url.searchParams.set("variant",option.value);window.history.replaceState({},"",url.toString())};selector.addEventListener("change",update);update();});
